// extracted by mini-css-extract-plugin
export default {"button":"Yl-z","reviewSort":"Zl-z"};